export const violenceOptions = [
  { value: 0, label: "None." },
  { value: 1, label: "Minor - little or brief violence." },
  { value: 2, label: "Mild - several scenes or scenes of longer duration." },
  { value: 3, label: "Significant - descriptive violence throughout." },
  { value: 4, label: "Heavy - violence is intense or gory." },
];